/**
 @Developper: BenAli Faker
 @Company: SMART-INFO
 @Post: CTO
 @Date:07/02/2021
 @Time:21:14
 **/
import VenteLigneBase from "./VenteLigneBase";
import Produit from "../../produit/modele/Produit";
import Stock from "../../stock/model/Stock";
import BonSortieLigneProduit from "../../bon_sortie/model/BonSortieLigneProduit";
import LangueService from "../../../i18n/service/LangueService";

export default class VenteLigneProduit extends VenteLigneBase{

    /**
     * @type{Produit}
     */
    #_produit;

    /**
     * @type{Stock}
     */
    #_stock=null;



    /**
     * si la vente est en cours de création par un vendeur externe (donc il est attaché a un bon de sortie)
     * @type{BonSortieLigneProduit}
     */
    #_bonSortieLigneProduit=null;


    constructor() {
        super();
        this.discriminator="produit";
    }

    get produit() {
        return this.#_produit;
    }

    set produit(value) {
        this.#_produit = value;
    }


    get stock() {
        return this.#_stock;
    }

    set stock(value) {
        this.#_stock = value;
    }

    get bonSortieLigneProduit() {
        return this.#_bonSortieLigneProduit;
    }

    set bonSortieLigneProduit(value) {
        this.#_bonSortieLigneProduit = value;
    }


    getDesignation(locale=LangueService.getInstance().activeLangue.locale) {
        let designation=super.getDesignation(locale);
        if(designation===''&&this.produit!==null){
            designation=this.produit.getDesignation(locale);
            this.addDesignation(locale,designation);
        }
        return designation;
    }


    static createObjetFromJson(venteLigneJson,venteLigne) {
        let venteLigneProduit=new VenteLigneProduit();
        super.createObjetFromJson(venteLigneJson,venteLigneProduit);
        if(venteLigneJson.produit!==null){
            venteLigneProduit.produit=Produit.createProduitFromJson(venteLigneJson.produit);
        }
        return venteLigneProduit;
    }


    /**
     *
     * @return {number} le nombre disponible pour vente
     */
    getQuantiteDisponiblePourVente() {
        if(this.#_bonSortieLigneProduit!=null)//vente en passant par bon sortie
        {
            return this.#_bonSortieLigneProduit.getQuantiteDisponibleVente();
        }else{ //vente directe sans passer par bon sortie
            return this.#_stock.quantite;
        }
    }
}